import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
function FadeInSection({
  children,
  delay = 0
}: {
  children: React.ReactNode;
  delay?: number;
}) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <motion.div ref={ref} initial={{
    opacity: 0,
    y: 24
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {}} transition={{
    duration: 0.5,
    delay,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-558">
      {children}
    </motion.div>;
}
export function DisclaimerPage() {
  return <div className="bg-charcoal min-h-screen" data-id="element-559">
      <section className="pt-32 pb-20 px-4 sm:px-6 lg:px-8" data-id="element-560">
        <div className="max-w-3xl mx-auto" data-id="element-561">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-562">
            <h1 className="text-3xl sm:text-4xl font-bold text-cream mb-3" data-id="element-563">
              Disclaimer
            </h1>
            <p className="text-sm text-[#7a7672] mb-12" data-id="element-564">
              Última actualización: enero 2025
            </p>
          </motion.div>

          {/* Prominent disclaimer box */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="bg-surface border border-accent/20 rounded-2xl p-6 mb-10" data-id="element-565">
            <p className="text-sm text-[#b8b4ae] leading-relaxed" data-id="element-566">
              <strong className="text-cream" data-id="element-567">Aviso importante:</strong> Reclutas
              Digitales no garantiza ingresos, resultados financieros ni
              métricas específicas de ningún tipo. Los testimonios, casos de
              estudio y ejemplos presentados en este sitio reflejan experiencias
              individuales y no son representativos de resultados típicos.
            </p>
          </motion.div>

          <div className="space-y-10" data-id="element-568">
            <FadeInSection data-id="element-569">
              <div data-id="element-570">
                <h2 className="text-xl font-semibold text-cream mb-3" data-id="element-571">
                  1. Sin garantía de ingresos
                </h2>
                <p className="text-[#b8b4ae] leading-relaxed text-sm" data-id="element-572">
                  Ningún contenido en este sitio web debe interpretarse como una
                  garantía o promesa de ingresos, ganancias o resultados
                  financieros específicos.
                </p>
              </div>
            </FadeInSection>

            <FadeInSection delay={0.05} data-id="element-573">
              <div data-id="element-574">
                <h2 className="text-xl font-semibold text-cream mb-3" data-id="element-575">
                  2. Resultados individuales
                </h2>
                <p className="text-[#b8b4ae] leading-relaxed text-sm" data-id="element-576">
                  Los resultados presentados en testimonios y casos de estudio
                  son experiencias individuales. Estos resultados no son típicos
                  ni representativos de lo que todos los participantes pueden
                  esperar.
                </p>
              </div>
            </FadeInSection>

            <FadeInSection delay={0.1} data-id="element-577">
              <div data-id="element-578">
                <h2 className="text-xl font-semibold text-cream mb-3" data-id="element-579">
                  3. No somos asesores financieros
                </h2>
                <p className="text-[#b8b4ae] leading-relaxed text-sm" data-id="element-580">
                  Reclutas Digitales es una empresa de consultoría e
                  implementación de sistemas de marketing y operaciones. No
                  somos asesores financieros, contadores, abogados ni agentes de
                  seguros licenciados.
                </p>
              </div>
            </FadeInSection>

            <FadeInSection delay={0.15} data-id="element-581">
              <div data-id="element-582">
                <h2 className="text-xl font-semibold text-cream mb-3" data-id="element-583">
                  4. Información de terceros
                </h2>
                <p className="text-[#b8b4ae] leading-relaxed text-sm" data-id="element-584">
                  Este sitio puede hacer referencia a herramientas de terceros
                  (como GoHighLevel, Meta Ads, WhatsApp Business API). No somos
                  responsables por el funcionamiento o cambios en los términos
                  de estos servicios.
                </p>
              </div>
            </FadeInSection>

            <FadeInSection delay={0.2} data-id="element-585">
              <div data-id="element-586">
                <h2 className="text-xl font-semibold text-cream mb-3" data-id="element-587">
                  5. Precisión del contenido
                </h2>
                <p className="text-[#b8b4ae] leading-relaxed text-sm" data-id="element-588">
                  Hacemos esfuerzos razonables para mantener la información
                  actualizada y precisa. Sin embargo, no garantizamos la
                  exactitud o integridad de ningún contenido.
                </p>
              </div>
            </FadeInSection>

            <FadeInSection delay={0.25} data-id="element-589">
              <div data-id="element-590">
                <h2 className="text-xl font-semibold text-cream mb-3" data-id="element-591">
                  6. Uso bajo su propio riesgo
                </h2>
                <p className="text-[#b8b4ae] leading-relaxed text-sm" data-id="element-592">
                  El uso de la información, estrategias y sistemas presentados
                  en este sitio es bajo su propio riesgo y responsabilidad.
                </p>
              </div>
            </FadeInSection>

            <FadeInSection delay={0.3} data-id="element-593">
              <div data-id="element-594">
                <h2 className="text-xl font-semibold text-cream mb-3" data-id="element-595">
                  7. Contacto
                </h2>
                <p className="text-[#b8b4ae] leading-relaxed text-sm" data-id="element-596">
                  Si tiene preguntas sobre este disclaimer, contáctenos a través
                  del formulario disponible en nuestro sitio web.
                </p>
              </div>
            </FadeInSection>
          </div>
        </div>
      </section>
    </div>;
}